import type { IconName } from '$lib/components/icons/types';
import type { Locale } from '$lib/i18n/types';

export const langData: Record<Locale, { text: string; icon: IconName; url: string }> = {
	'fr-FR': { text: 'Français', icon: 'flag-fr', url: 'https://www.viamichelin.fr/' },
	'fr-BE': { text: 'Français - Belgique', icon: 'flag-be', url: 'https://fr.viamichelin.be/' },
	'fr-CH': { text: 'Français - Suisse', icon: 'flag-ch', url: 'https://fr.viamichelin.ch/' },
	'nl-BE': { text: 'Nederlands - België', icon: 'flag-be', url: 'https://nl.viamichelin.be/' },
	'de-DE': { text: 'Deutsch', icon: 'flag-de', url: 'https://www.viamichelin.de/' },
	'de-AT': { text: 'Deutsch - Österreich', icon: 'flag-at', url: 'https://www.viamichelin.at/' },
	'de-CH': { text: 'Deutsch - Schweiz', icon: 'flag-ch', url: 'https://de.viamichelin.ch/' },
	'en-US': {
		text: 'English - International',
		icon: 'flag-international',
		url: 'https://www.viamichelin.com/',
	},
	'en-GB': { text: 'English', icon: 'flag-gb', url: 'https://www.viamichelin.co.uk/' },
	'en-IE': { text: 'English - Ireland', icon: 'flag-ie', url: 'https://www.viamichelin.ie/' },
	'es-ES': { text: 'Español', icon: 'flag-es', url: 'https://www.viamichelin.es/' },
	'it-IT': { text: 'Italiano', icon: 'flag-it', url: 'https://www.viamichelin.it/' },
	'it-CH': { text: 'Italiano - Svizzera', icon: 'flag-ch', url: 'https://it.viamichelin.ch/' },
	'nl-NL': { text: 'Nederlands', icon: 'flag-nl', url: 'https://www.viamichelin.nl/' },
	'pt-PT': { text: 'Português', icon: 'flag-pt', url: 'https://www.viamichelin.pt/' },
};
